import client from "../client";
import { ApprovalRequestInterface } from "../../models/ProcurementModule/ApprovalRequest";
import { ApprovalStatus } from "../../enums/approvalStatus";

const listName = "PurchaseOrderApprovalPersons";
class ApprovalRequestsService {
  async GetMyApprovalRequests() {
    try {
      const url = `/api/${listName}/GetMyApprovalRequests`;
      const { data } = await client.post<ApprovalRequestInterface[]>(url, {
        url: "",
      });

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  async GetByPurchaseOrderId(purchaseOrderId: string | undefined) {
    try {
      if (purchaseOrderId) {
        const url = `/api/${listName}/getbypurchaseOrder/${purchaseOrderId}`;
        const { data } = await client.post<ApprovalRequestInterface[]>(url, {
          url: "",
        });

        return data;
      } else return [];
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async UpdateStatus(
    purchaseOrderApprovalPersonId: string,
    status: ApprovalStatus,
    comment: string
  ) {
    try {
      const url = `/api/${listName}/UpdateStatus`;
      const { data } = await client.post<ApprovalRequestInterface>(url, {
        status,
        purchaseOrderApprovalPersonId,
        comment,
      });

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new ApprovalRequestsService();
